import { useSearchParams } from "react-router-dom";

/**
 * True when this page was reached via a module tile's deep link
 * (EmsProjectsTreeView.jsx / PlantModuleNav's buildModuleHref) naming a
 * specific sub-tab, rather than browsed to directly - those links append
 * `standalone=1` because the user already picked exactly one destination,
 * so the surrounding tab bar/module nav (built for browsing between tabs)
 * is just noise there. NavTabs and PageHeader both read this to hide
 * themselves. Read from the query string, not the hash - the hash still
 * carries which tab to show and keeps changing as NavTabs writes to it.
 */
export default function useStandaloneView() {
  const [searchParams] = useSearchParams();
  return searchParams.get("standalone") === "1";
}
